import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_TABLE_FAILURE,
  FETCH_TABLE_REQUEST,
  FETCH_TABLE_SUCCESS,
  TableActionType,
} from '../types/tableType';
import { Table } from 'src/types/model';

export const fetchTableRequest = (): TableActionType => ({
  type: FETCH_TABLE_REQUEST,
});

export const fetchTableSuccess = (data: Table[]): TableActionType => ({
  type: FETCH_TABLE_SUCCESS,
  payload: data,
});

export const fetchTableFailure = (error: string): TableActionType => ({
  type: FETCH_TABLE_FAILURE,
  payload: error,
});

export const fetchTable = () => {
  return async (dispatch: Dispatch<TableActionType>) => {
    dispatch(fetchTableRequest());
    try {
      const request = await Service.get('/floors/tables');
      const data: Table[] = request?.data?.data?.tables;
      dispatch(fetchTableSuccess(data));
    } catch (error: any) {
      dispatch(fetchTableFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch table');
    }
  };
};
